import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import history from '../../history';
import { authSuccess, loginFailure } from '../../actions/auth';
import { fetchSession } from '../../api/v4';
import { fetchUserProfile } from '../../actions/user';
import {
  fetchUserCompaniesResponse,
  setActiveCompany,
  setActiveLocation
} from '../../actions/company';

export default function SsoLogin() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      dispatch(loginFailure('Missing SSO token.'));
      history.push({ pathname: '/login', state: { ssoError: true } });
      return;
    }

    try {
      sessionStorage.setItem('token', token);

      fetchSession()
        .then(responseData => {
          // Mirror post-login flow
          sessionStorage.setItem('user', JSON.stringify(responseData.user));

          const user = { ...responseData.user };
          user.securityQuestions = responseData.securityQuestions;

          dispatch(authSuccess());
          dispatch(fetchUserProfile(user));

          let companies = responseData.companies || [];

          let whitelabel = responseData?.whitelabel;
          if (whitelabel)
            whitelabel = {
              ...whitelabel,
              logo: whitelabel?.logo?.source_url
            };

          if (whitelabel)
            localStorage.setItem('whitelabel', JSON.stringify(whitelabel));
          else localStorage.removeItem('whitelabel');

          companies = companies.map(res => {
            const allGroupsHidden = res?.groups?.length
              ? res.groups.every(g => g.isHidden)
              : false;
            return {
              ...res,
              allLocations: res.groups,
              locations: res.groups,
              allGroupsHidden
            };
          });

          const companyNames = companies.map(c => c.name);
          localStorage.setItem('companies', companyNames.join(', '));

          dispatch(fetchUserCompaniesResponse(companies));

          const firstCompany = companies?.[0];
          const firstGroup = firstCompany?.groups?.[0];
          if (firstCompany) dispatch(setActiveCompany(firstCompany));
          if (firstGroup) dispatch(setActiveLocation(firstGroup));

          history.push('/home');
        })
        .catch(() => {
          dispatch(loginFailure('Session retrieval failed.'));
          history.push({ pathname: '/login', state: { ssoError: true } });
        });
    } catch (e) {
      dispatch(loginFailure('SSO login failed.'));
      history.push({ pathname: '/login', state: { ssoError: true } });
    }
  }, [dispatch, location.search]);

  return null;
}
